import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from '../services/api';

function LoginPage() {
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await login(credentials.username, credentials.password);
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('username', response.data.username);
      localStorage.setItem('role', response.data.role);
      localStorage.setItem('name', response.data.name || response.data.username);
      navigate(response.data.role === 'VERIFIER' ? '/verify' : '/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Invalid credentials');
    }
  };

  return (
    <div className="container">
      <div className="header">
        <div style={{display: 'flex', alignItems: 'center', gap: '20px', justifyContent: 'center', width: '100%'}}>
          <img src="/misk_logo.png" alt="MISK Logo" style={{height: '60px'}} />
          <h1>MISK Staff Login</h1>
        </div>
      </div>

      <div className="card" style={{maxWidth: '400px', margin: '0 auto'}}>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Username</label>
            <input 
              type="text" 
              value={credentials.username}
              onChange={(e) => setCredentials({...credentials, username: e.target.value})}
              required 
            />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input 
              type="password" 
              value={credentials.password}
              onChange={(e) => setCredentials({...credentials, password: e.target.value})}
              required 
            />
          </div>
          <button type="submit" className="btn btn-primary" style={{width: '100%'}}>Login</button>
          {error && <p className="error">{error}</p>}
        </form>
        <button className="btn btn-logout" style={{width: '100%', marginTop: '10px'}} onClick={() => navigate('/')}>
          Back to Home
        </button>
      </div>
    </div>
  );
}

export default LoginPage;
